import { render, staticRenderFns } from "./ReporteRecepcionPlantulas.vue?vue&type=template&id=72f5d42e&"
import script from "./ReporteRecepcionPlantulas.vue?vue&type=script&lang=ts&"
export * from "./ReporteRecepcionPlantulas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
